var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/components/SubMenu.js",
  _this = this;
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@sm/wds-react';
import SMHeaderContext from '../../../SMHeaderContext';
import { NavBarAnonContext } from '../NavBarAnonContext';
import useSubMenuStyles from './Submenu/useSubMenuStyles';
export var SubMenu = function SubMenu(_ref) {
  var submenuKey = _ref.submenuKey,
    title = _ref.title,
    children = _ref.children;
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  var _useContext2 = useContext(NavBarAnonContext),
    submenuOpened = _useContext2.submenuOpened;
  var _useSubMenuStyles = useSubMenuStyles(),
    SubMenuContainer = _useSubMenuStyles.SubMenuContainer,
    SubMenuTitle = _useSubMenuStyles.SubMenuTitle;
  var submenuClassName = "".concat(SubMenuContainer, " ").concat(submenuKey.toLowerCase(), " lang-").concat(lang, " ").concat(lang !== 'en' ? 'locale' : '', " ").concat(submenuOpened === submenuKey ? 'submenu-open' : '');
  return /*#__PURE__*/React.createElement("div", {
    className: submenuClassName,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, lang !== 'en' && /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionTitle",
    className: SubMenuTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, title), children);
};
export default SubMenu;
SubMenu.propTypes = {
  title: PropTypes.string.isRequired,
  submenuKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=SubMenu.js.map